module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"customer_explain":"Check or add any extra information that should appear on your customer form.","use_checkout":"Use Checkout Form in"},"id":{"customer_explain":"Cek atau tambah informasi lainnya yang perlu tampil dalam form pelanggan.","use_checkout":"Guna Checkout Form pada"}}')
  delete Component.options._Ctor
}
